import React from 'react';

import OnboardingTour from './OnboardingTour';
import {
  TXTCLI_LetXs_Go,
  TXTCLI_Lets_get_you_started_by_explai_ELL,
  TXTCLI_WELCOME_TO_SPIN_X_GO
} from './OnboardingTourStart.messages.json';

const OnboardingTourStart: React.FC = () => (
  <OnboardingTour
    heading={TXTCLI_WELCOME_TO_SPIN_X_GO}
    text={TXTCLI_Lets_get_you_started_by_explai_ELL}
    primaryButtonText={TXTCLI_LetXs_Go}
  />
);

export default OnboardingTourStart;
